import React, { useMemo } from 'react'

export default function ProgressCircle({ percentage = 0, force_color = null }) {
    const color = useMemo(() => {
        if (force_color == 'red') return '#E07580';
        if (percentage == 100) return "#A6D0A8"
        return '#03B0F7'

    }, [percentage, force_color])
    return (
        <Pie percentage={percentage} colour={color} />
    )
}





const Circle = ({ colour, percentage, strokePct, circ, r }) => {

    return (
        <circle
            r={r - 5}
            cx={r}
            cy={r}
            fill="transparent"
            stroke={colour}
            strokeWidth={"3px"}
            strokeDasharray={circ}
            strokeDashoffset={percentage ? strokePct : 0}
            strokeLinecap="round"
        ></circle>
    );
};

const Text = ({ percentage }) => {
    return (
        <text
            x="50%"
            y="50%"
            dominantBaseline="central"
            textAnchor="middle"
            fontSize={"0.6em"}
        >
            {percentage.toFixed(0)}%
        </text>
    );
};

const Pie = ({ percentage, colour }) => {
    const size = 35;

    const r = size / 2;
    const circ = 2 * Math.PI * r;
    const strokePct = ((100 - percentage) * circ) / 100;

    return (
        <svg width={size} height={size}>
            <g transform={`rotate(-90 ${r} ${r})`}>
                {['#E07580', "#A6D0A8"].includes(colour) && (
                    <circle r={r - 5} cx={r} cy={r} fill={colour == '#E07580' ? "#FBEDEE" : colour == '#A6D0A8' ? "#E7F5EB" : ""} />
                )}
                <Circle colour={'lightgrey'} percentage={100} strokePct={5} circ={circ} r={r} />
                {!!percentage && (
                    <Circle colour={colour} percentage={percentage} strokePct={strokePct} circ={circ} r={r} />
                )}
            </g>
            <Text percentage={percentage} />
        </svg>
    );
};
